/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../../../contexts/auth';
import { useAppState } from '../../../../contexts/appState';
import { handleSetOptionsData } from '../../../../reducersAndActions/actions/appStateActions';
import { getNonLoginOptions } from '../../../../api/home';
import Footer from '../../../common/Footer/Footer';
import DynamicSearchBar from '../../../DynamicSearchBar/index';
import styles from './NonLogged.module.scss';
import '../../../../styles';
import { Business } from '../../../common';

function NonLoginBody({ handleOptionClick, handleOnLanding }) {
  const [appState] = useAppState();
  const [authState, dispatch] = useAuth();
  const { selectedBusiness, type } = authState;

  const [resp, setResp] = useState();
  const [, setLoading] = useState(true);
  const [, setOptionsData] = useState([]);
  const [, setContractType] = useState(sessionStorage.getItem('contractType') || '');

  const getList = async () => {
    const data = await getNonLoginOptions(type);
    return data;
  };

  useEffect(() => {
    setLoading(true);
    if (authState?.loginPopup?.nonlogin && authState?.optionsData?.options?.length === 0 && type) {
      const res = getList();
      setOptionsData(res.options);
      handleSetOptionsData(dispatch, {
        optionsData: { options: res.options, contractType: res?.contractType },
        contractType: res?.contractType,
        ecs: false,
      });
      sessionStorage.setItem('contractType', res?.contractType);
      setContractType(res?.contractType);
      setLoading(false);
    }
    if (authState?.optionsData?.options?.length > 0 || (authState?.loginPopup?.nonlogin && !authState?.sidResponse)) {
      setLoading(false);
    }
    setTimeout(() => {
      setLoading(false);
    }, 6000);
  }, [selectedBusiness?.docid, type, authState?.loginPopup?.nonlogin, authState.userDetails?.mobile]);

  const getData = async () => {
    try {
      const data = await getNonLoginOptions(type);
      setResp(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <section className="cspage cstickets no-highlighting">
        {(type === 'business' || authState?.loginPopup?.nonlogin) && (
          <DynamicSearchBar
            handleOptionClick={handleOptionClick}
            contractType={appState?.optionsData?.contractType}
            ecsFlag={appState?.optionsData?.ecsFlag || false}
            jdrrBannerFlag={appState?.optionsData?.jdrrBannerFlag || false}
            page="csportal"
          />
        )}

        <div className="cshotkeybox animated fadeIn p-20">
          <div className="hotkeybox_text">
            <div className={`${styles.Contract__Heading} font16 fw600 color111 color111 text_center`}>
              Hi! How can we help you today?
            </div>
          </div>
          <ul className="hotkeybox_listgroup">
            {resp?.options?.length > 0 &&
              resp?.options.map((each, idx) => (
                <li key={idx} className={`${styles.Contract__ListGroupItem}`} onClick={() => handleOptionClick(each)}>
                  <div className={`${styles.Contract__ListGroupAnchor} whitefill_animate`}>
                    <div className={`csicon hotkeybox_icon ${each.icon}`} />
                    <div className={`${styles.Contract__ListGroupText} pl-12 pr-20`}>
                      <div className={`${styles.Contract__ListGroupTitle} no_login_list font14 fw600 color111`}>
                        {each.title}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
          </ul>
          {type === 'business' ? <Business handleOnLanding={handleOnLanding} /> : type === '' ? <Footer /> : ''}
        </div>
      </section>
    </>
  );
}

export default NonLoginBody;

NonLoginBody.propTypes = {
  handleOptionClick: PropTypes.func,
  handleOnLanding: PropTypes.func,
};
